import { AutomationRuleActionsEnum } from 'src/editor/shared/types/automation-rules/actions-types'
import { defaultActionValues } from '../constants/default-action-values'

export const getDefaultActionValue = (
  slug: AutomationRuleActionsEnum,
  maxActionId: number,
) => {
  const defaultAction = { ...defaultActionValues[slug] }
  defaultAction.id = maxActionId + 1
  defaultAction.created = true
  return defaultAction
}
